<template>
  <div>
    <div class="fullwidth small-bottom-padding">
      <div class="flex-start">
        <div class="aa-top" v-if="!$store.getters.isNonEnglish">
          <h1>{{ $nippets.allAnimators.heading }}</h1>
          <h2>{{ $nippets.allAnimators.h2 }}</h2>
          <div class="aa-space"></div>
        </div>
        <h1 v-if="$store.getters.isNonEnglish">{{ $nippets.allAnimators.heading }}</h1>
        <div>
          <search-widget right />
        </div>
      </div>
      <div class="full-flex">
        <div class="button-panel">
          <small-button large :sel="mode === 'random'" v-on:click="changeMode('random')">{{ snippets.random }}</small-button>
          <small-button large :sel="mode === 'az'" v-on:click="changeMode('az')">{{ snippets.az }}</small-button>
          <small-button large :sel="newArtists" v-on:click="goNew()">{{ snippets.new }}</small-button>
          <small-button large :sel="showStyles" v-on:click="showStyles = !showStyles">
            {{ snippets.style }}
          </small-button>
          <location-selector v-model="location" v-on:input="changeRegion" />

        </div>
        <div class="button-panel">
          <ix-router-link to="/animation-commissioning" class="bigbutton green">{{ $nippets.ourGuide }}</ix-router-link>
        </div>
      </div>
    </div>
    <transitionable-panel :activated="showStyles" :delay="50" slow>
      <div class="fullwidth darker" v-if="showStyles" style="margin-bottom:40px">
        <div class="close-box" v-on:click="showStyles = false" />
        <style-browser animation />
      </div>
    </transitionable-panel>
    <transition name="fade">
      <div class="fullwidth" :class="{ 'no-top-padding': !showStyles}" v-show="loaded">
        <animator-grid :artists="artists" v-on:load="gridLoaded" />
        <div class="a-right">
          <top-button />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import StyleBrowser from '@/components/panels/StyleBrowser.vue'
import TransitionablePanel from '@/components/widgets/TransitionablePanel.vue'
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import AnimatorGrid from '@/components/panels/AnimatorGrid.vue'
import TopButton from '@/components/buttons/TopButton.vue'
import LocationSelector from '@/components/widgets/LocationSelector.vue'
import MetatagPage from '@/mixins/MetatagPage.js'

export default {
  mixins: [ MetatagPage ],
  components: {
    StyleBrowser,
    TransitionablePanel,
    SearchWidget,
    AnimatorGrid,
    LocationSelector,
    TopButton
  },
  data: function () {
    return {
      loaded: false,
      showStyles: false,
      artists: [],
      orgArtists: null,
      galleries: [],
      mode: 'random',
      newArtists: false,
      location: 'ZZ'
    }
  },
  computed: {
    snippets: function () {
      return this.$nippets.allArtists
    }
  },
  created: function () {
    this.mode = this.$store.state.azSortMode
    this.location = this.$store.state.azLocation
    this.newArtists = this.$store.state.azNewMode
    this.loadGalleries()
    this.loadArtists()
  },
  
  methods: {
    gridLoaded: function () {
      this.loaded = true
    },
    
    loadArtists: async function () {
      if(this.artists.length < 1) {
        this.loaded = false
      }
      try {
        this.artists = []
        if(this.orgArtists === null) {
          await this.$store.dispatch('fetchArtists')
          // make a shallow copy
          this.orgArtists = this.$store.getters.nonExcludedArtists.filter(el => el.animation)
          
        }
        let res = this.orgArtists
        let lang = this.$store.state.lang.toLowerCase()
        if(this.newArtists) {
          res = res.filter(el => el.is_new)
        }
        if(this.location !== 'ZZ'){
          res = res.filter(el => el.region === this.location)
        }
        else {
          
          res = res.filter(el => { return (el.region !== 'DE' || el.show_on_all) })
          res = res.filter(el => { return  !el.hiddens.includes(lang) })
        }
        
        this.sortArtists(res)
        this.artists = res
        
      }
      catch(err){
        console.log('error getting artists', err)
      }
    },
    changeRegion: function (code) {
      this.showStyles = false
      this.location = code
      this.$store.commit('setAzLocation', this.location)
      this.loadArtists()
      
      
    },
    goNew: function () {
      this.showStyles = false
      this.newArtists = !this.newArtists
      this.$store.commit('setAzNewMode', this.newArtists)
      this.loadArtists()
    },
    loadGalleries: async function () {
      this.galleries = await this.$store.dispatch('fetchGalleries')
    },
    changeMode: function (modename) {
      this.showStyles = false
      this.mode = modename
      this.loadArtists()
      this.$store.commit('setAzSortMode', this.mode)
    },
    sortArtists: function (res) {
      if(this.mode === 'random'){
        res.sort((el, el1) => { return el.rnd - el1.rnd })
      }
      else if(this.mode === 'az') {
        res.sort((el, el1) => { return el.name.localeCompare(el1.name) })
      }
    }
    
  },
  watch: {
    item: function () {
      if(this.item === 'new') {
        this.newArtists = true
      }
    },
    '$store.state.azLocation': function () {
      if(this.$store.state.azLocation !== this.location) {
        this.location = this.$store.state.azLocation
        this.loadArtists()
        this.goToTop()
      }
    }
  }
}
</script>

<style>

h1{
  font-size:36px;
  line-height:40px;
  font-weight:500;
  margin-top:0;
  margin-bottom:30px;
  width:75%;
}

.aa-top{
  display:flex;
  align-items:flex-start;
  margin-bottom: 30px;
}

.aa-top h1{
    margin:0 20px 0 0;
    width:440px;
    line-height:36px;
}

.aa-top h2{
  width: 50%;
  margin:0 20px 0 0;
  color:#000;
  font-size:24px;
  font-weight:400;
  line-height:34px;
}

.aa-space{
  width:10%;
}

.full-flex{
  display:flex;
  justify-content:space-between;
}

@media screen and (max-width:1024px)
{
  .aa-top{
    display:block;
  }

  .aa-top h2{
    width:auto;
    font-size:18px;
    margin-top:10px;
    line-height:23px;
  }

  .aa-space{
    display:none;
  }
}

@media screen and (max-width:768px){
  .search-holder{
    display:none!important;
  }
  h1{
    width:100%;
    font-size:24px;
    line-height:28px;
  }
  .aa-top h1{
    width:auto;
    line-height:normal;
  }
  .aa-top {
    margin-bottom:0;
  }
  .full-flex{
    display: block;
  }
}


</style>
